import VisibilityIcon from "@mui/icons-material/Visibility";
import {
	IconButton,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";
import { useValidImage } from "src/hooks/useValidImage";
import { IFairAllEvents } from "src/Types/module/FairEvent/FairEventType";

interface IProps {
	sEvent: IFairAllEvents;
	serial: number;
}

const EventTableRow = ({ sEvent, serial }: IProps) => {
	const theme = useTheme();
	const imgSrc = useValidImage(
		sEvent.event_photo,
		"/static/images/placeholders/covers/5.jpg"
	);

	return (
		<>
			<TableRow hover key={sEvent.event_id}>
				<TableCell align='center'>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{serial}
					</Typography>
				</TableCell>
				<TableCell align='center'>{sEvent.event_title}</TableCell>
				<TableCell align='center'>{sEvent.event_venu}</TableCell>
				<TableCell align='center'>
					{moment(sEvent.event_date).format("MMM Do YY")}
				</TableCell>
				<TableCell align='center'>
					<img
						width={30}
						height={30}
						style={{
							borderRadius: "50%",
							marginRight: "10px",
						}}
						src={imgSrc}
						alt={sEvent.event_title}
					/>
				</TableCell>
				<TableCell align='center'>{sEvent.event_status}</TableCell>

				<TableCell align='center'>
					<Link
						to={`/fair-event/all-event-list/${sEvent.event_id.toString()}`}
					>
						<Tooltip title='View' arrow>
							<IconButton
								sx={{
									"&:hover": {
										background:
											theme.colors.primary.lighter,
									},
									color: theme.palette.primary.main,
								}}
								color='inherit'
								size='small'
							>
								<VisibilityIcon fontSize='small' />
							</IconButton>
						</Tooltip>
					</Link>
				</TableCell>
			</TableRow>
		</>
	);
};

export default EventTableRow;
